import type { LatenessTier } from '../../work-queue/timeThresholds.ts';

export type WaitingInbox = 'messages' | 'notifications';

const HOUR_MS = 3_600_000;
const DAY_MS = 24 * HOUR_MS;

// A value of N means "waiting N ms or longer" reaches that tier.
type WaitingThresholdsMs = Record<LatenessTier, number>;

export const MESSAGE_WAITING_THRESHOLDS_MS: WaitingThresholdsMs = {
    late: 4 * HOUR_MS,
    moderate: 12 * HOUR_MS,
    extreme: 24 * HOUR_MS
};

export const NOTIFICATION_WAITING_THRESHOLDS_MS: WaitingThresholdsMs = {
    late: DAY_MS,
    moderate: 2 * DAY_MS,
    extreme: 3 * DAY_MS
};

const THRESHOLDS_BY_INBOX: Record<WaitingInbox, WaitingThresholdsMs> = {
    messages: MESSAGE_WAITING_THRESHOLDS_MS,
    notifications: NOTIFICATION_WAITING_THRESHOLDS_MS
};

const TIERS_WORST_FIRST: readonly LatenessTier[] = ['extreme', 'moderate', 'late'];

export function waitingTier(ageMs: number, inbox: WaitingInbox): LatenessTier | null {
    if (!Number.isFinite(ageMs)) return null;
    const thresholds = THRESHOLDS_BY_INBOX[inbox];
    return TIERS_WORST_FIRST.find((tier) => ageMs >= thresholds[tier]) ?? null;
}
